// THIS FILE IS AUTOGENERATED

export interface Version {
  commit: string;
  version: string;
  app: string;
}

export const version = {
  app: "myqq",
  commit: "f03b8e2cdaddfeb996f1f60abd844e4cfa44a1b6",
  version: "1.130.0",
};
